export default __webpack_public_path__ + "static/media/home.c4ee14ce.svg";